import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { useLocalization } from "../../contexts/LocalizationContext";

const Loading = ({
  size = "medium",
  text,
  fullScreen = false,
  className = "",
}) => {
  const { theme } = useTheme();
  const { t } = useLocalization();

  const getSizeStyles = () => {
    switch (size) {
      case "small":
        return { width: "20px", height: "20px", borderWidth: "2px" };
      case "large":
        return { width: "48px", height: "48px", borderWidth: "4px" };
      default:
        return { width: "32px", height: "32px", borderWidth: "3px" };
    }
  };

  const spinnerStyles = {
    ...getSizeStyles(),
    border: `${getSizeStyles().borderWidth} solid ${theme.border}`,
    borderTop: `${getSizeStyles().borderWidth} solid ${theme.primary}`,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  const containerStyles = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    ...(fullScreen && {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: theme.background,
      zIndex: 9999,
    }),
  };

  const textStyles = {
    color: theme.textSecondary,
    fontSize: "14px",
    fontWeight: "500",
  };

  return (
    <div style={containerStyles} className={className}>
      <div style={spinnerStyles} />
      {text && <div style={textStyles}>{text}</div>}
      {!text && fullScreen && <div style={textStyles}>{t("loading")}</div>}
    </div>
  );
};

// Spinner для использования внутри других компонентов
export const Spinner = ({ size = "small", color }) => {
  const { theme } = useTheme();

  const getSizeStyles = () => {
    switch (size) {
      case "small":
        return { width: "16px", height: "16px", borderWidth: "2px" };
      case "large":
        return { width: "24px", height: "24px", borderWidth: "3px" };
      default:
        return { width: "20px", height: "20px", borderWidth: "2px" };
    }
  };

  const spinnerStyles = {
    ...getSizeStyles(),
    border: `${getSizeStyles().borderWidth} solid transparent`,
    borderTop: `${getSizeStyles().borderWidth} solid ${color || theme.primary}`,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  return <div style={spinnerStyles} />;
};

export default Loading;
